// extracted by mini-css-extract-plugin
export default {"CountriesFeature":"vu_a bhh_b"};